module.exports = __webpack_public_path__ + "static/media/external-link.bdcbd439.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/external-link.svg
// module id = 299
// module chunks = 0